import Homepage from "./components/Homepage";
import { Routes, Route } from "react-router-dom";
import './App.css';
import Login from "./components/Login";
import Registration from "./components/Registration";
import ResetPassword from "./components/ResetPassword";
import Profile from "./components/Profile";
import RegistrationSuccess from "./components/RegistrationSuccess";
import CheckoutSuccess from "./components/CheckoutSuccess";
import RoleProtectedRoute from "./components/middleware/RoleProtectedRoute";
import ProfileOperator from "./components/ProfileOperator";
import ProfileAdmin from "./components/ProfileAdmin";
import AvailableOperatorsWidget from './components/base/availableOperatorsComponent';
import ChangePasswordComponent from "./components/ChangePasswordComponent";
import PrivacyPolicy from "./components/PrivacyPolicy";

function App() {
    return (
        <>
            <Routes>
                <Route path="/" element={<Homepage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/registration" element={<Registration />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/change-password" element={<ChangePasswordComponent />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/success" element={<RegistrationSuccess />} />
                <Route path="/payment-succeed" element={<CheckoutSuccess />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route
                    path="/profile-operator"
                    element={
                        <RoleProtectedRoute
                            element={<ProfileOperator />}
                            requiredRole="leader"
                        />
                    }
                />
                <Route
                    path="/profile-admin"
                    element={
                        <RoleProtectedRoute
                            element={<ProfileAdmin />}
                            requiredRole="admin"
                        />
                    }
                />
            </Routes>
            <AvailableOperatorsWidget />
        </>
    );
}

export default App;
